import { Messages } from '../../../../codegen/Localize';
import { moveContents } from '../../../actions/MoveContentsAction';
import { ISetProjectAction } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatabase, anyItemIsEmbeddedDatasource, anyItemIsEmbeddedTable } from './IEntityActionHelpers';

export const MoveAction: IEntityAction<IContentInfo, ISetProjectAction> = {
  name: EntityActionNames.Move,
  translateName: Messages.move_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !anyItemIsEmbeddedDatasource(targetItems)
      && !anyItemIsEmbeddedDatabase(targetItems)
      && !anyItemIsEmbeddedTable(targetItems);
  },
  isClickable: (availableActions: ISetProjectAction) => !!(availableActions && availableActions.setProject),
  createReduxAction: (targetItems: IContentInfo[]) => moveContents(targetItems)
};
